"use strict";
/**
 * Tree Select for savant nested compartment select
 * has limited API as this is not an exported component.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Messages = require("../../../codegen/Messages");
var formContextHOC_1 = require("./formContextHOC");
var InputHelper_1 = require("./InputHelper");
var useEscPropagationHandler_1 = require("../../../hooks/useEscPropagationHandler");
var react_dropdown_tree_select_1 = require("react-dropdown-tree-select");
var util_1 = require("../../../utils/util");
var TreeSelect = function (_a) {
    var label = _a.label, labelledBy = _a.labelledBy, defaultExpandAll = _a.defaultExpandAll, defaultExpandedOptionValues = _a.defaultExpandedOptionValues, disabled = _a.disabled, dropDownClass = _a.dropDownClass, filterPlaceholder = _a.filterPlaceholder, fieldName = _a.fieldName, noResultsText = _a.noResultsText, onChange = _a.onChange, openByDefault = _a.openByDefault, options = _a.options, placeholder = _a.placeholder, testId = _a.testId, value = _a.value;
    var _b = __read(React.useState(false), 2), isOpen = _b[0], setIsOpen = _b[1];
    var _c = __read(React.useState(false), 2), userHasInteracted = _c[0], setUserHasInteracted = _c[1];
    // react-dropdown-tree-select propagates ESC to parent and closes modals, this handler contains that
    var containerRef = React.createRef();
    var _d = useEscPropagationHandler_1.default(containerRef), allowEscPropagation = _d.allowEscPropagation, blockEscPropagation = _d.blockEscPropagation;
    var onFocus = function () {
        blockEscPropagation();
        setIsOpen(true);
    };
    var onBlur = function () { return setIsOpen(false); };
    var texts = {
        placeholder: isOpen && filterPlaceholder ? filterPlaceholder : placeholder,
        noMatches: noResultsText || Messages.TreeSelect.noResults(),
        label: isOpen
            ? Messages.TreeSelect.openUAText()
            : Messages.TreeSelect.closedUAText()
    };
    return (React.createElement(InputHelper_1.default, { disabled: disabled, fieldName: fieldName, value: value, onChange: onChange }, function (helper) {
        var mapData = React.useCallback(function (data) {
            return data.reduce(function (acc, item) {
                // FEAT - disabled must never be undefined so children of disabled parents can be selected
                var children = item.children, _a = item.disabled, disabled = _a === void 0 ? false : _a, toolTip = item.toolTip, rest = __rest(item, ["children", "disabled", "toolTip"]);
                var isExpanded = defaultExpandAll ||
                    (Array.isArray(defaultExpandedOptionValues) &&
                        defaultExpandedOptionValues.indexOf(item.value) >= 0);
                acc.push(__assign({ disabled: disabled }, (Array.isArray(children) && {
                    children: mapData(children)
                }), (isExpanded && { expanded: true }), (helper.value === item.value && { checked: true }), (toolTip && {
                    title: toolTip,
                    actions: [{ className: " ", text: "ⓘ", title: toolTip }]
                }), rest));
                return acc;
            }, []);
        }, [helper.value, defaultExpandAll, defaultExpandedOptionValues]);
        var optionData = React.useMemo(function () { return mapData(options); }, [
            options,
            mapData
        ]);
        var handleChange = React.useCallback(function (currentNode) {
            allowEscPropagation();
            helper.onChange && helper.onChange(currentNode.value);
        }, [helper.onChange]);
        // Suppress submitting form on enter on drop-down
        var handleKeyDown = React.useCallback(function (event) {
            var target = event.target;
            if (event.key === "Enter" && target.id.startsWith(helper.fieldId)) {
                event.preventDefault();
                event.stopPropagation();
            }
        }, []);
        // used to close drop-downs set to auto-open on "initial" since they don't auto-close well
        var handleClickOutside = React.useCallback(function () {
            setUserHasInteracted(true);
        }, []);
        React.useEffect(function () {
            document.addEventListener("keydown", handleKeyDown);
            openByDefault &&
                document.addEventListener("mousedown", handleClickOutside);
            return function () {
                document.removeEventListener("keydown", handleKeyDown);
                openByDefault &&
                    document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [handleKeyDown]);
        return (React.createElement("div", { "data-test-id": testId, ref: containerRef },
            React.createElement(react_dropdown_tree_select_1.default, __assign({}, util_1.ariaProps({ label: label, labelledBy: labelledBy }), { className: dropDownClass, data: optionData, disabled: disabled, id: helper.fieldId, keepTreeOnSearch: true, mode: "radioSelect", onBlur: onBlur, onChange: handleChange, onFocus: onFocus, showDropdown: openByDefault && !userHasInteracted ? "initial" : "default", texts: texts, 
                // noop for click on Tooltips
                onAction: function () { } }))));
    }));
};
exports.default = formContextHOC_1.default(TreeSelect);
//# sourceMappingURL=TreeSelect.js.map